<template>
  <div>
    <template v-if="count">
      <div v-for="v in list" :key="`card-update-record-${v.id}`" class="item-box">
        <template v-for="updateType in cardUpdateTypes">
          <template v-if="updateType.value === v.update_type">
            <div :key="`${v.id}-${updateType.value}-icon`" class="icon-box">
              <v-icon :name="updateType.icon"/>
            </div>
            <div :key="`${v.id}-${updateType.value}-content`" class="item-content border-bottom">
              <div class="record-list-item flex-justify-between">
                <router-link :to="RouteConfig.cardUpdateRecordDetail.to(v.id)" class="record-list-title">{{ updateType.name }}</router-link>
                <div class="time accent-color">{{ v.add_time | timeToYmdHi }}</div>
              </div>
              <div class="record-list-item">
                课卡：「<router-link :to="RouteConfig.cardDetail.to(v.card_id)" class="primary-color">{{ v.card_name }} No.{{v.card_id}}</router-link>」；

                <template v-if="v.old_student_id !== v.student_id">
                  所属学员：「<router-link :to="RouteConfig.studentDetail.to(v.old_student_id)" class="primary-color">{{ v.old_student_name }}</router-link>」改为「<router-link :to="RouteConfig.studentDetail.to(v.student_id)" class="primary-color">{{ v.student_name }}</router-link>」；
                </template>
                办卡门店：「{{v.store_name}}」；
                <template v-if="v.old_register_time !== v.register_time">
                  办卡日期：「{{ v.old_register_time | timeToYmdHis }} 」改为「{{ v.register_time | timeToYmdHis }}」；
                </template>

                <template v-if="v.old_start_time_auto !== v.start_time_auto">
                  自动开卡日期：「{{ v.old_start_time_auto | timeToYmdHis }} 」改为「{{ v.start_time_auto | timeToYmdHis }}」；
                </template>

                <template v-if="v.old_card_name !== v.card_name">
                  课卡名称：「{{ v.old_card_name }}」改为「{{ v.card_name }}」；
                </template>

                <template v-if="v.old_card_type_name !== v.card_type_name">
                  课卡类型：「{{ v.old_card_type_name }}」改为「{{ v.card_type_name }}」；
                </template>

                <template v-if="v.old_expire_days !== v.expire_days">
                  有效天数：「{{ v.old_expire_days }} 天」改为「{{ v.expire_days }} 天」；
                </template>

                <template v-if="v.old_expire_time !== v.expire_time">
                  有效日期：「{{ v.old_expire_time | timeToYmdHi }} 」改为「{{ v.expire_time | timeToYmdHi }}」；
                </template>

                <template v-if="v.old_expire_number !== v.expire_number">
                  有效次数：「{{ v.old_expire_number | toYuan }} 次」改为「{{ v.expire_number | toYuan }} 次」；
                </template>

                <template v-if="v.old_store_names !== v.store_names">
                  适用范围：「{{ v.old_store_names ? `仅限${ v.old_store_names }店使用` : '全国通用'}}」
                  改为「{{ v.store_names ? `仅限${ v.store_names }店使用` : '全国通用'}}」；
                </template>

                <template v-if="v.old_store_names !== v.store_names">
                  适用范围：「{{ v.old_store_names ? `仅限${ v.old_store_names }店使用` : '全国通用'}}」
                  改为「{{ v.store_names ? `仅限${ v.store_names }店使用` : '全国通用'}}」；
                </template>

                <div v-if="(v.old_remark_files || []).length || (v.remark_files || []).length" class="remark-diff">
                  备注文件：
                  <template v-if="(v.old_remark_files || []).length">
                    <template v-for="(f, k) in v.old_remark_files">
                      <a :key="`old-remark-thumb-${k}`" class="remark-inline-link" :href="f.file_url" target="_blank" :title="f.file_name || f.file_url"><img v-if="isImageFile(f)" class="remark-inline-thumb" :src="f.file_url" alt=""><span v-else class="remark-inline-file">{{ (f.file_ext || 'FILE').toUpperCase() }} · {{ f.file_name }}</span></a>
                    </template>
                  </template>
                  <span v-else class="info-color">未上传</span>
                  <template v-if="JSON.stringify(v.old_remark_files || []) !== JSON.stringify(v.remark_files || [])">
                    <v-icon name="arrow-right" class="diff-arrow primary-color"/>
                    <template v-if="(v.remark_files || []).length">
                      <template v-for="(f, k) in v.remark_files">
                        <a :key="`new-remark-thumb-${k}`" class="remark-inline-link" :href="f.file_url" target="_blank" :title="f.file_name || f.file_url"><img v-if="isImageFile(f)" class="remark-inline-thumb" :src="f.file_url" alt=""><span v-else class="remark-inline-file">{{ (f.file_ext || 'FILE').toUpperCase() }} · {{ f.file_name }}</span></a>
                      </template>
                    </template>
                    <span v-else class="info-color">未上传</span>
                  </template>
                </div>

                <template v-if="v.store_names">
                  <template v-if="v.old_store_limit_expire_days !== v.store_limit_expire_days">
                    仅限{{ v.store_names }}店使用天数：「{{ v.old_store_limit_expire_days }} 天」
                    改为「{{ v.store_limit_expire_days }} 天」；
                  </template>
                </template>

                <template v-if="v.old_actual_payment !== v.actual_payment">
                  实际付款：「{{ v.old_actual_payment | toYuan }} 元」改为「{{ v.actual_payment | toYuan }} 元」；
                </template>

                <template v-if="v.old_is_disable_column !== v.is_disable_column">
                  禁止预约专栏：「{{ v.old_is_disable_column ? '是' : '否' }}」改为「{{ v.is_disable_column ? '是' : '否' }}」；
                </template>

                所补差价：「{{ v.update_payment | toYuan }} 元」；
                补差价付款方式：「{{ findPaymentModeName(v.update_payment_mode) }} 」；
                <template v-if="v.apply_administrator_name">申请修改原因：「<strong class="danger-color">{{ v.update_remark }}</strong>」。</template>

                <div v-if="(v.apply_remark_files || []).length" class="remark-diff">
                  上传凭证：
                  <template v-for="(f, k) in v.apply_remark_files">
                    <a :key="`stop-proof-${k}`" class="remark-inline-link" :href="f.file_url" target="_blank" :title="f.file_name || f.file_url"><img v-if="isImageFile(f)" class="remark-inline-thumb" :src="f.file_url" alt=""><span v-else class="remark-inline-file">{{ (f.file_ext || 'FILE').toUpperCase() }} · {{ f.file_name }}</span></a>
                  </template>
                </div>

              </div>
              <div class="store-name accent-color">
                <span v-if="v.apply_administrator_name" class="operator">
                  申请人：{{ v.apply_administrator_name }}
                </span>
                <span v-if="v.apply_administrator_name && v.administrator_name" class="operator">
                  审核人：{{ v.administrator_name }}
                </span>
                <span v-if="!v.apply_administrator_name && v.administrator_name" class="operator">
                  修改人：{{ v.administrator_name }}
                </span>
                办卡所在门店：{{ v.store_name }}
              </div>
            </div>
          </template>
        </template>
      </div>

      <div v-if="count" class="pagination-box">
        <el-pagination
          :background="true"
          :page-sizes="pageSizes"
          :current-page.sync="page"
          :page-size.sync="size"
          :total="count"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handlePageChange"
          @current-change="handlePageChange"
        />
      </div>
    </template>
    <div v-else class="empty-tip-box">暂无课卡修改记录</div>
  </div>
</template>

<script>
import scrollTo from "@/utils/scroll-to";
import { getCardUpdateRecordsByStudentId } from "@/api/card-update-record";
import cardUpdateTypes, { cardUseControlTypeValues } from '@/enums/cardUpdateTypes';
import RouteConfig from "@/router/config";
import { findPaymentModeName } from "@/enums/paymentModes";

export default {
  props: {
    studentId: Number,
  },
  data: () => ({
    cardUpdateTypes,
    cardUseControlTypeValues,
    RouteConfig,
    list: [],
    count: 0,
    page: 1,
    size: 8,
    pageSizes: [10, 20, 30],
  }),
  beforeMount() {
    this.getList();
  },
  methods: {
    findPaymentModeName,
    isImageFile(f) {
      const ext = (f.file_ext || (f.file_name ? f.file_name.split('.').pop() : '') || '').toUpperCase();
      return ['JPG', 'JPEG', 'PNG', 'GIF', 'WEBP'].includes(ext);
    },
    async getList() {
      const { isError, data } = await getCardUpdateRecordsByStudentId({
        student_id: this.studentId,
        page: this.page,
        size: this.size,
      });
      if (isError) return;

      this.list = data.list;
      this.count = data.count;
    },
    handlePageChange() {
      this.getList();
      scrollTo(0, 350);
    },
  },
};
</script>

<style src="@/components/student-detail-record.css" scoped/>
<style scoped>
.record-list-title {
  color: var(--color-primary);
}

.remark-diff {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.diff-arrow {
  color: #409EFF !important;
  flex-shrink: 0;
}

.remark-inline-link {
  display: inline-block;
  margin-right: 4px;
}

.remark-inline-thumb {
  width: 36px;
  height: 36px;
  vertical-align: middle;
  border: 1px solid #ebeef5;
  border-radius: 3px;
  object-fit: cover;
}

.remark-inline-file {
  display: inline-block;
  vertical-align: middle;
  max-width: 180px;
  padding: 6px 8px;
  font-size: 12px;
  line-height: 1.2;
  color: #606266;
  background: #f0f2f5;
  border: 1px solid #ebeef5;
  border-radius: 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
